export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/util/eventConsts.js
// module id = 159
// module chunks = 0